import { render, staticRenderFns } from "./formularioDinamico.vue?vue&type=template&id=2d64b5b7"
import script from "./formularioDinamico.vue?vue&type=script&lang=js"
export * from "./formularioDinamico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports